import React, { useState, useEffect } from "react";
import { Button, Form } from "reactstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { loginUser } from "../../store/actions";
import { MetaTags } from "react-meta-tags";
import styles from "./Login.module.css";

import logo from "../../assets/images/logo-limpia.png";

function Login(props) {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { username, password } = formData;



  const onChange = (e) => {
    console.log("📝 [LOGIN COMPONENT] Campo actualizado:", e.target.name, "=", e.target.value);
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    


    // Validaciones básicas
    if (!username.trim()) {
      console.warn("⚠️ [LOGIN COMPONENT] Usuario vacío");
      return;
    }

    if (!password.trim()) {
      console.warn("⚠️ [LOGIN COMPONENT] Contraseña vacía");
      return;
    }

    setIsSubmitting(true);
    props.loginUser({ username: username.trim(), password }, props.history);
  };

  // Reset isSubmitting cuando cambie el estado de loading
  useEffect(() => {
    if (!props.loading) {
      setIsSubmitting(false);
    }
  }, [props.loading]);

  // Función para obtener el mensaje de error apropiado
  const getErrorMessage = () => {
    if (!props.error) return null;

    console.log("🔴 [LOGIN COMPONENT] Procesando error:", props.error);

    // Si hay un mensaje de detalle específico
    if (props.error.detail) {
      return props.error.detail;
    }

    // Manejo de errores por tipo
    switch (props.error.type) {
      case "CONNECTION_ERROR":
        return "Error de conexión. Por favor, intenta nuevamente.";
      case "NETWORK_ERROR":
        return "No se pudo conectar con el servidor. Verifica tu conexión a internet.";
      case "SERVER_ERROR":
        return "Error del servidor. Por favor, intenta más tarde.";
      case "USER_DATA_ERROR":
        return "Error al obtener información del usuario.";
      default:
        // Manejo de errores específicos del backend
        if (props.error.non_field_errors) {
          return props.error.non_field_errors[0] || "Credenciales inválidas.";
        }
        if (props.error.username) {
          return `Usuario: ${props.error.username[0]}`;
        }
        if (props.error.password) {
          return `Contraseña: ${props.error.password[0]}`;
        }
        // Mensaje genérico
        return "Error de autenticación. Verifica tus credenciales.";
    }
  };

  const errorMessage = getErrorMessage();



  return (
    <div className={styles.wrapper}>
      <MetaTags>
        <title> Ciudad Limpia | Login </title>
      </MetaTags>

      <div className={styles.overlay}>
        <div className={styles.logoContainer}>
          <img src={logo} alt="Ciudad Limpia" className={styles.logo} />
        </div>

        <div className={styles.loginCard}>
          <h2>Iniciar Sesión</h2>
          <p>Bienvenido, por favor ingresa tus credenciales</p>

          <Form onSubmit={onSubmit}>
            <input
              className={styles.input}
              type="text"
              name="username"
              placeholder="Usuario"
              value={username}
              onChange={onChange}
              required
              disabled={isSubmitting || props.loading}
            />
            <input
              className={styles.input}
              type="password"
              name="password"
              placeholder="Contraseña"
              value={password}
              onChange={onChange}
              required
              disabled={isSubmitting || props.loading}
            />

            {errorMessage && (
              <div className={styles.errorContainer}>
                <p className={styles.error}>
                  <span className={styles.errorIcon}>⚠️</span>
                  {errorMessage}
                </p>
              </div>
            )}

            <Button 
              type="submit" 
              className={`text-white btn-success ${styles.buttonlogin2}`}
              disabled={isSubmitting || props.loading || !username.trim() || !password.trim()}
            >
              {isSubmitting || props.loading ? (
                <>
                  <span className={styles.spinner}></span>
                  Ingresando...
                </>
              ) : (
                "Ingresar"
              )}
            </Button>
          </Form>

          <div className={styles.links}>
            <a href="#!">¿Olvidaste tu contraseña?</a>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  const { error, loading } = state.Login;
  return { error, loading };
};

export default withRouter(connect(mapStateToProps, { loginUser })(Login));
